var map = {
	"./all-doctors.svg": 67749,
	"./ambulances.svg": 42413,
	"./appointment.svg": 60704,
	"./ask.svg": 11278,
	"./calendar.svg": 69923,
	"./call-doctor.svg": 68476,
	"./chat-call-center.svg": 90320,
	"./chat.svg": 58746,
	"./checklist.svg": 40590,
	"./complexity.svg": 99998,
	"./direction.svg": 3253,
	"./discount.svg": 76312,
	"./doctor.svg": 29874,
	"./document.svg": 90207,
	"./family.svg": 67066,
	"./favorites.svg": 41431,
	"./folder.svg": 22823,
	"./home-page.svg": 46504,
	"./logout.svg": 67019,
	"./ndfl.svg": 46741,
	"./padlock2.svg": 39070,
	"./parking.svg": 28783,
	"./profile.svg": 19315,
	"./review.svg": 46868,
	"./services.svg": 64542,
	"./sign-out-option.svg": 67293,
	"./support.svg": 20405,
	"./telemed.svg": 92717,
	"./wallet-filled-money.svg": 17720,
	"./whats-app.svg": 47152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27563;